import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, mediaUrl } from "../lib/api";
import { initMetaPixel } from "../lib/metaPixel";

const DEFAULT_SETTINGS = {
  brand_name: "Zaveri Trunk",
  brand_tagline: "WHOLESALE · TRUST · TIMELESS",
  trademark_type: "TM",
  site_mode: "both",
  store_mode: "HYBRID",
  wholesale_enabled: true,
  retail_enabled: true,
  enable_cod: true,
  retail_price_visibility: "show",
  texts: {
    footer_quick_links: "Quick Links",
    footer_contact: "Contact Us"
  },
  footer_benefits: [
    { icon: "package", title: "Bulk Orders", subtitle: "Best Wholesale Prices" },
    { icon: "shield", title: "Secure Payments", subtitle: "100% Safe & Secure" },
    { icon: "refresh-ccw", title: "Easy Returns", subtitle: "Hassle-Free Returns" },
    { icon: "headphones", title: "Customer Support", subtitle: "Mon - Sat (10 AM - 7 PM)" }
  ],
  quick_links: [
    { label: "About Us", href: "/about" },
    { label: "Collections", href: "/products" },
    { label: "FAQs", href: "/faqs" },
    { label: "Shipping Policy", href: "/shipping-policy" },
    { label: "Return Policy", href: "/return-policy" },
    { label: "Terms & Conditions", href: "/terms" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Contact Us", href: "#contact" }
  ],
  contact: {
    phone: "+91 90824 44611",
    email: "support@zaveritrunk.com",
    hours: "Mon - Sat (10 AM - 7 PM)"
  },
  meta_pixel: { enabled: true, pixel_id: "1532708972227403" }
};

const SettingsContext = createContext({ settings: DEFAULT_SETTINGS, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(() => {
    try {
      const cached = localStorage.getItem("site-settings");
      return cached ? { ...DEFAULT_SETTINGS, ...JSON.parse(cached) } : DEFAULT_SETTINGS;
    } catch {
      return DEFAULT_SETTINGS;
    }
  });

  const refresh = useCallback(() => {
    return api.get("/settings").then((r) => {
      if (r?.data) {
        const merged = { ...DEFAULT_SETTINGS, ...r.data };
        setSettings(merged);
        try {
          localStorage.setItem("site-settings", JSON.stringify(merged));
        } catch {}
      }
    }).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    if (!settings) return;
    if (settings.brand_name) document.title = settings.brand_name;
    const favUrl = settings.favicon?.url || settings.favicon_url;
    if (favUrl) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = mediaUrl(favUrl);
    }

    // Initialize Meta Pixel
    if (settings.meta_pixel) {
      initMetaPixel(settings.meta_pixel);
    } else {
      initMetaPixel({ enabled: true, pixel_id: "1532708972227403" });
    }
  }, [settings]);

  return <SettingsContext.Provider value={{ settings, refresh }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);

